import { useGetTheme } from '../../../../hooks/use-get-theme';
import { useLocale } from '../../../../locale/use-locale';

const useLanguagePicker = () => {
  const { locale, setLocale, availableLanguages } = useLocale();
  const theme = useGetTheme();

  return {
    language: locale,
    setLanguage: setLocale,
    availableLanguages,
    theme,
  };
};

export default useLanguagePicker;
